export default "__VITE_ASSET__DUGoK1cg__"